@if (!hideStates) {
  <div class="flex flex-col gap-sm">
    <!-- State Selector -->
    <div class="flex flex-wrap gap-sm">
      @for (item of statesList; track item) {
        <div
          class="shop-select-item"
          [ngClass]="{
            'shop-select-active': selectedGroups?.includes(item),
            'shop-select-inactive': !selectedGroups?.includes(item),
            'shop-select-partial': selectedPartialGroups?.includes(item)
          }"
          (click)="toggleSelectedGroup(item)"
        >
          {{ item }}
          {{
            numberOfShopsSelectedInEachState[item] > 0
              ? '(' +
                numberOfShopsSelectedInEachState[item] +
                (numberOfShopsSelectedInEachState[item] !== shopsGroupByStates[item].length
                  ? '/' + shopsGroupByStates[item].length
                  : '') +
                ')'
              : ''
          }}
        </div>
      }
      <div
        class="shop-select-item"
        [ngClass]="{
          'shop-select-active': selectedGroups?.includes('saturday'),
          'shop-select-inactive': !selectedGroups?.includes('saturday'),
          'shop-select-partial': selectedPartialGroups?.includes('saturday')
        }"
        (click)="toggleSaturdaySelection()"
      >
        Saturday Open
        {{
          numberOfShopsSelectedOpenOnSaturday > 0
            ? '(' +
              numberOfShopsSelectedOpenOnSaturday +
              (numberOfShopsSelectedOpenOnSaturday !== numberOfShopsOpenOnSaturday
                ? '/' + numberOfShopsOpenOnSaturday
                : '') +
              ')'
            : ''
        }}
      </div>
    </div>

    <!-- Regional Manager Selector -->
    <div class="flex flex-wrap gap-sm">
      @for (item of regionalManagersList; track item) {
        <div
          class="shop-select-item"
          [ngClass]="{
            'shop-select-active': selectedGroups?.includes(item.value),
            'shop-select-inactive': !selectedGroups?.includes(item.value),
            'shop-select-partial': selectedPartialGroups?.includes(item.value)
          }"
          (click)="toggleSelectedGroup(item.value, 'regionalManager')"
        >
          {{ item.label }}
          {{
            numberOfShopsSelectedForEachManager[item.value] > 0
              ? '(' +
                numberOfShopsSelectedForEachManager[item.value] +
                (numberOfShopsSelectedForEachManager[item.value] !==
                shopsGroupByManager[item.value].length
                  ? '/' + shopsGroupByManager[item.value].length
                  : '') +
                ')'
              : ''
          }}
        </div>
      }
    </div>

    <!-- District Manager + Location Group Selector -->
    <div class="flex flex-wrap items-center gap-sm">
      @for (item of districtManagersList; track item) {
        <div
          class="shop-select-item"
          [ngClass]="{
            'shop-select-active': selectedGroups?.includes(item.value),
            'shop-select-inactive': !selectedGroups?.includes(item.value),
            'shop-select-partial': selectedPartialGroups?.includes(item.value)
          }"
          (click)="toggleSelectedGroup(item.value, 'districtManager')"
        >
          {{ item.label }}
          {{
            numberOfShopsSelectedForEachDistrictManager[item.value] > 0
              ? '(' +
                numberOfShopsSelectedForEachDistrictManager[item.value] +
                (numberOfShopsSelectedForEachDistrictManager[item.value] !==
                shopsGroupByDistrictManager[item.value].length
                  ? '/' + shopsGroupByDistrictManager[item.value].length
                  : '') +
                ')'
              : ''
          }}
        </div>
      }
      @if (districtManagersList.length > 0 && locationGroupsList.length > 0) {
        <span class="text-txt-secondary text-sm select-none">|</span>
      }
      @for (item of locationGroupsList; track item) {
        <div
          class="shop-select-item"
          [ngClass]="{
            'shop-select-active': selectedGroups?.includes(item.value),
            'shop-select-inactive': !selectedGroups?.includes(item.value),
            'shop-select-partial': selectedPartialGroups?.includes(item.value)
          }"
          (click)="toggleSelectedGroup(item.value, 'locationGroup')"
        >
          {{ item.label }}
          {{
            numberOfShopsSelectedForEachLocationGroup[item.value] > 0
              ? '(' +
                numberOfShopsSelectedForEachLocationGroup[item.value] +
                (numberOfShopsSelectedForEachLocationGroup[item.value] !==
                shopsGroupByLocationGroup[item.value].length
                  ? '/' + shopsGroupByLocationGroup[item.value].length
                  : '') +
                ')'
              : ''
          }}
        </div>
      }
    </div>
  </div>
}

<div class="flex flex-col gap-base" [ngClass]="{ 'mt-base': !hideStates }">
  @if (showLimitMessage) {
    <div class="text-base leading-base text-txt-secondary">
      You can select up to {{ maxSelectable }} locations to display on the graphic at the same time.
    </div>
  }
  <form class="w-full" [formGroup]="form">
    <lla-input
      class="block -my-sm"
      [normalInputId]="searchInputId"
      controlName="searchText"
      type="text"
      placeholder="Search"
      icon="search"
      size="small"
      [clearable]="true"
    ></lla-input>

    @if (allShopsList.length > 10) {
      <div
        class="mt-base py-sm px-base rounded-sm flex items-center justify-between gap-base"
        [ngClass]="{ 'bg-gray-100': showTakeOverFilter }"
      >
        <div class="flex items-center gap-sm">
          @if (showTakeOverFilter) {
            <div class="hidden md:block text-base leading-base text-txt">Take over date</div>
            <lla-input
              class="w-[107px] -my-sm"
              controlName="takeOverType"
              type="select"
              [whiteMode]="true"
              [icon]="'arrow-down'"
              iconSize="15px"
              size="small"
              [items]="allTakeOverTypeTypes"
            ></lla-input>
            <lla-input
              class="-my-sm"
              controlName="takeOverDate"
              type="date"
              [whiteMode]="true"
              size="small"
              icon="calendar-bold"
              iconSize="15px"
              iconColor="#9CA9AF"
              placeholder="Take Over Date"
              [maxDate]="undefined"
            ></lla-input>
            <div class="flex text-txt-secondary cursor-pointer" (click)="resetTakeOverFilters()">
              <svg-icon key="close-light" class="!text-xs"></svg-icon>
            </div>
          }
        </div>
        <div
          class="flex items-center justify-center self-stretch cursor-pointer text-txt-secondary"
          (click)="changeTakeOverStatus()"
        >
          <svg-icon
            key="arrow-down"
            class="!text-xs"
            [ngClass]="{ 'rotate-180': showTakeOverFilter }"
          ></svg-icon>
        </div>
      </div>
    }
  </form>

  @if (!hideStates) {
    <div>
      <lla-button
        (click)="selectAllFilterdShops()"
        variant="ghost"
        size="small-shrink"
        extraBtnClass="!w-max !text-primary !p-0"
      >
        {{ allFilterdShopsSelected() ? 'Unselect' : 'Select' }}
        {{ filterdShopList.length === allShopsList.length ? 'all' : 'filters' }}
      </lla-button>
    </div>
  }

  <div
    class="2xl:hidden flex flex-col md:grid grid-flow-col grid-cols-2 gap-x-2xl gap-y-sm"
    [ngStyle]="{
      'grid-template-rows': 'repeat(' + Math.ceil(this.filterdShopList.length / 2) + ', minmax(0, 1fr))'
    }"
  >
    @for (item of filterdShopList; track item) {
      <lla-checkbox
        [item]="item"
        [controlName]="controlName"
        [disabled]="isItemDisabled(item)"
      ></lla-checkbox>
    }
  </div>

  <div
    class="hidden 2xl:grid grid-flow-col grid-cols-{{ numberOfColumns }} gap-x-2xl gap-y-sm"
    [ngStyle]="{
      'grid-template-rows':
        'repeat(' + Math.ceil(this.filterdShopList.length / numberOfColumns) + ', minmax(0, 1fr))'
    }"
  >
    @for (item of filterdShopList; track item) {
      <lla-checkbox
        [item]="item"
        [controlName]="controlName"
        [disabled]="isItemDisabled(item)"
      ></lla-checkbox>
    }
  </div>
</div>
